module.exports = __webpack_public_path__ + "img/acne_ypgnbg_c_scale,w_200-blur.3acc8b76.jpg";